import { Fragment, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Block, CRIcon, CRRender } from '../../../crRender'
import UploadedItem from './UploadedItem'


export const SUPPORTED_FORMATS = {
    image: 'image/*',
    excel: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    pdf: 'application/pdf'
}

const UploadFileHints = {
    [SUPPORTED_FORMATS.image]: 'supported-formats-images',
    [SUPPORTED_FORMATS.excel]: 'supported-formats-excel',
    [SUPPORTED_FORMATS.pdf]: 'supported-formats-pdf'
}

const UploadFileIcons = {
    [SUPPORTED_FORMATS.image]: 'flat-color-icons:add-image',
    [SUPPORTED_FORMATS.excel]: 'vscode-icons:file-type-excel',
    [SUPPORTED_FORMATS.pdf]: 'vscode-icons:file-type-pdf2'
}


const UploadFile = ({
    accept,
    multiple,
    maxFiles,
    maxFileSize,
    fileInputRef,
    files,
    previews,
    isDragging,
    errors,
    handleFileSelect,
    handleDragEnter,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleRemoveFile,
    getFileIcon,
    formatFileSize
}) => {
    const { t } = useTranslation()


    const GetItemData = useCallback((data) => ({
        preview: previews.find((p) => p.id === data.id),
        fileErrors: errors[data.id] || []
    }), [previews, errors])

    return (
        <div className="file-upload-popup-content">
            <div className={`file-drop-zone ${isDragging ? 'dragging' : ''}`}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current?.click()} >

                <CRIcon icon={UploadFileIcons[accept]} className="upload-icon" />
                <Block isRender={isDragging} className="upload-text">{t('drop-files-here')}</Block>
                <Block isRender={!isDragging} className="upload-text">{t('drag-drop-files')}</Block>

                <div className="upload-hint">{t(UploadFileHints[accept])}</div>
                <Block isRender={[SUPPORTED_FORMATS.image, SUPPORTED_FORMATS.pdf, SUPPORTED_FORMATS.excel].includes(accept)}
                    className="upload-hint">{t('select-files')} , {t('max-file-size')}: {formatFileSize(maxFileSize)}</Block>
                <Block isRender={!!maxFiles}
                    className="upload-hint">{t('current-uploaded-files')}: {files.length}</Block>

            </div>

            <input
                ref={fileInputRef}
                type="file"
                accept={accept}
                multiple={multiple}
                onChange={handleFileSelect}
                style={{ display: 'none' }}
            />

            <Block isRender={files.length > 0} className="file-list-container">
                <h4 className="file-list-title">{t('selected-files')}</h4>
                <div className="file-list">
                    {files.mapWithKey((fileItem) =>
                        <Fragment key={fileItem.key} >
                            <UploadedItem
                                fileItem={fileItem}
                                preview={GetItemData(fileItem)?.preview}
                                fileErrors={GetItemData(fileItem)?.fileErrors}
                                handleRemoveFile={handleRemoveFile}
                                getFileIcon={getFileIcon}
                                formatFileSize={formatFileSize}
                            />
                        </Fragment>)}
                </div>
                {/*

                <CRRender isRender={multiple && files.length < maxFiles}>
                    <button type="button" className="add-more-files-btn" onClick={() => fileInputRef.current?.click()} >
                        <CRIcon icon="mdi:plus" />
                        {t('add-more-files')}
                    </button>
                </CRRender>
                        */}
            </Block>
        </div >
    )
}

export default UploadFile

